<div class="vendor-modal-container">
  @if (vendorLabel) {
    @if (vendorLabel !== 'InnerTrak') {
      <div class="vendor-modal-container__button">
        <span class="button-label">{{
          buttonLabel ? buttonLabel : 'Ships from '
        }}</span>
        <a class="link link-underline fw-normal" (click)="toggleModal()">{{
          vendorLabel
        }}</a>
      </div>
    }
    @if (vendorLabel === 'InnerTrak') {
      <div class="vendor-modal-container__button">
        <span class="button-label">Shipping Directly from Vendor</span>
      </div>
    }
  }
  @if (!vendorLabel) {
    <a class="link extra-small fw-normal" (click)="toggleModal()"
      >Vendor Info</a
    >
  }
  <app-modal
    #vendorModal
    title="Vendor Information"
    class="vendor-modal-container__body"
  >
    <div class="app-modal-body">
      <p>
        <i>
          Disclaimer: All returns are subject to the individual vendor’s
          discretion and policy.</i
        >
      </p>
      <span class="app-modal-body__line"></span>
      @for (vendor of vendors; track vendor) {
        <h2>{{ vendor.label }}</h2>
        <div class="app-modal-body__info">
          <p class="me-2">
            Phone #:<span class="ms-2">{{ vendor.phone }}</span>
          </p>
          <p class="me-2">
            Email:<span class="ms-2"
              ><a
                class="link small"
                href="{{ getEmailLink(vendor.email) }}"
                target="_blank"
                >{{ vendor.email }}</a
              ></span
            >
          </p>
          @if (vendor.returnPolicy) {
            <p>
              Return Policy:<span class="ms-2">{{ vendor.returnPolicy }}</span>
            </p>
          }
        </div>
        <span class="app-modal-body__line"></span>
      }
    </div>
  </app-modal>
</div>
